import React from 'react';
import clsx from 'clsx';
import { Image } from '@colonist/ui';
import styles from './ProfileSelectionGrid.module.scss';
/** Grid of selectable profile images such as colors or avatars. */ export const ProfileSelectionGrid = ({ options, selectedId, onSelect, onDisabledSelect })=>{
    const handleSelect = (option)=>{
        if (option.disabled) onDisabledSelect(option.id);
        else onSelect(option.id);
    };
    return /*#__PURE__*/ React.createElement("div", {
        className: styles.container
    }, options.map((option)=>{
        var _option_dimmed;
        return /*#__PURE__*/ React.createElement("button", {
            key: option.id,
            type: "button",
            className: clsx(styles.item, ((_option_dimmed = option.dimmed) !== null && _option_dimmed !== void 0 ? _option_dimmed : option.disabled) && styles.disabled, option.id == selectedId && styles.selected),
            onClick: ()=>handleSelect(option),
            "aria-pressed": option.id == selectedId
        }, /*#__PURE__*/ React.createElement(Image, {
            className: styles.image,
            image: {
                src: option.imageUrl,
                alt: option.name
            }
        }));
    }));
};
